import React from 'react';
import Checkbox from '@material-ui/core/Checkbox'
import styles from './styles';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel'

const renderCheckbox = ({ input, label }) => (
   <FormGroup row>
      <FormControlLabel
          control={
            <Checkbox
            checked={input.value ? true : false}
            onChange={input.onChange}
          />
          }
          label={label}
        />
    
  </FormGroup>  
)

export default renderCheckbox;


// WEBPACK FOOTER //
// ./src/components/MaterialUi/renderCheckbox.js